import { EnquiryLifecycleStatusEnum } from "../enum"

export class CostSheetModel {
    buyer:string
    agent:string
    country:string
    destination:string
    shipmentTerms:string
    OceanFrightInUSD:number
    shipmentPeriod:string
    noOfContainers:number
    enqReceivedDate:string
    assesmentApprovalDate:string//feasibility steady state date
    qouteDate:string
    enquiryApprovedDate:string
    exchangeRate:number
    enquiryStatus:EnquiryLifecycleStatusEnum
    productRates:productRates[]
    ad:number
    cvd:number
    constructor(buyer:string,agent:string,country:string,destination:string,shipmentTerms:string,OceanFrightInUSD:number,shipmentPeriod:string,noOfContainers:number,enqReceivedDate:string,assesmentApprovalDate:string,qouteDate:string,enquiryApprovedDate:string,exchangeRate:number,enquiryStatus:EnquiryLifecycleStatusEnum,productRates:productRates[],ad:number,
        cvd:number){
        this.buyer = buyer
        this.agent = agent
        this.country = country
        this.destination = destination
        this.shipmentTerms = shipmentTerms
        this.OceanFrightInUSD = OceanFrightInUSD
        this.shipmentPeriod = shipmentPeriod
        this.noOfContainers = noOfContainers
        this.enqReceivedDate = enqReceivedDate
        this.assesmentApprovalDate = assesmentApprovalDate
        this.qouteDate = qouteDate
        this.enquiryApprovedDate = enquiryApprovedDate
        this.exchangeRate = exchangeRate
        this.enquiryStatus = enquiryStatus
        this.productRates = productRates
        this.ad = ad
        this.cvd = cvd
    }
}
export class productRates {
    productId:number
    quantity: number
    productName:string
    leadType:string
    yieldPer:number
    packCount:number
    rmCount:number
    prevailingRmRate:number
    rmCost:number
    manufacturingCost:number
    salesCommissionpercentage:number
    salesCommission:number
    packingMaterial:number
    freightAndForwardExpenses:number
    totalExpenses:number
    costOfProduction:number//per LB in SSD...
    fixedCost:number//...
    costOfSalesPerKgINR:number
    costOfSalesPerKgUSD:number
    costOfSalesPerLBUSD:number
    quotePrice:number
    buyerOfferPrice:number
    netPLOnBuyerPrice:number//PL:profitloss
    incentives:number
    totalProfitLoss:number
    plPercentage:number//on buyer price
    contributionPercentage:number//on buyer price
    prevConfirmedPrice:number
    prevailingMarketRate:number//...
    addedPriceToRmrate:number
    reducedPriceToRmRate:number
    costOfSalesForAddedRmRate:number
    styleWeighment:string
    category:string
    costOfSalesForReducedRmRate:number
    frozenYield:number
    adCVDpercentageVal:number
    totCostOfSalesPerLBUSD:number
    group:number
    cartons:number
    containers:number
    enquiryProductId?:number
    constructor(productId:number,quantity: number,productName:string,leadType:string,yieldPer:number,packCount:number,rmCount:number,prevailingRmRate:number,rmCost:number,manufacturingCost:number,salesCommissionpercentage:number,salesCommission:number,packingMaterial:number,freightAndForwardExpenses:number,totalExpenses:number,costOfProduction:number,fixedCost:number,costOfSalesPerKgINR:number,costOfSalesPerKgUSD:number,costOfSalesPerLBUSD:number,quotePrice:number,buyerOfferPrice:number,netPLOnBuyerPrice:number,incentives:number,totalProfitLoss:number,plPercentage:number,contributionPercentage:number,prevConfirmedPrice:number,prevailingMarketRate:number,addedPriceToRmrate:number,reducedPriceToRmRate:number,costOfSalesForAddedRmRate:number,costOfSalesForReducedRmRate:number,styleWeighment:string,category:string,frozenYield:number,adCVDpercentageVal:number,totCostOfSalesPerLBUSD:number,group:number,cartons:number,containers:number,enquiryProductId?:number){
        this.productId = productId
        this.quantity = quantity
        this.productName = productName
        this.leadType = leadType
        this.yieldPer = yieldPer
        this.packCount = packCount
        this.rmCount = rmCount
        this.prevailingRmRate = prevailingRmRate
        this.rmCost = rmCost
        this.manufacturingCost = manufacturingCost
        this.salesCommissionpercentage = salesCommissionpercentage
        this.salesCommission = salesCommission
        this.packingMaterial = packingMaterial
        this.freightAndForwardExpenses = freightAndForwardExpenses
        this.totalExpenses = totalExpenses
        this.costOfProduction = costOfProduction
        this.fixedCost = fixedCost
        this.costOfSalesPerKgINR = costOfSalesPerKgINR
        this.costOfSalesPerKgUSD = costOfSalesPerKgUSD
        this.costOfSalesPerLBUSD = costOfSalesPerLBUSD
        this.quotePrice = quotePrice
        this.buyerOfferPrice = buyerOfferPrice
        this.netPLOnBuyerPrice = netPLOnBuyerPrice
        this.incentives = incentives
        this.totalProfitLoss = totalProfitLoss
        this.plPercentage = plPercentage
        this.contributionPercentage = contributionPercentage
        this.prevConfirmedPrice = prevConfirmedPrice
        this.prevailingMarketRate = prevailingMarketRate
        this.addedPriceToRmrate = addedPriceToRmrate
        this.reducedPriceToRmRate = reducedPriceToRmRate
        this.costOfSalesForAddedRmRate = costOfSalesForAddedRmRate
        this.costOfSalesForReducedRmRate = costOfSalesForReducedRmRate
        this.enquiryProductId = enquiryProductId
        this.styleWeighment = styleWeighment
        this.category = category
        this.frozenYield = frozenYield
        this.adCVDpercentageVal = adCVDpercentageVal
        this.totCostOfSalesPerLBUSD = totCostOfSalesPerLBUSD
        this.group = group
        this.cartons = cartons
        this.containers = containers
    }
}